import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosBuzzOne } from '../../../../axios';
import { moduleName } from '../../module';
import { getPincodes, postPincode } from '../../utils/apiRoutes';

export const postPincodesAsync = createAsyncThunk(
  `${moduleName}/postPincodesAsync`,
  async (payload, { rejectWithValue }) => {
    try {
      const { bodyData } = payload;
      const response = await axiosBuzzOne({
        method: 'POST',
        url: postPincode(),
        data: bodyData,
      });
      const data = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getPinocodesListAsync = createAsyncThunk(
  `${moduleName}/getPinocodesListAsync`,
  async (payload) => {
    const { city, state } = payload;
    const response = await axiosBuzzOne({
      method: 'GET',
      url: getPincodes(),
      params: { city, state },
    });
    const data = response.data;
    return data;
  }
);

const launchSlice = createSlice({
  name: `${moduleName}/UserKycApproval`,
  initialState: {
    pincodes: null,
  },
  reducers: {},
  extraReducers: {
    [postPincodesAsync.pending]: (state) => {
      state.loading = true;
    },
    [postPincodesAsync.fulfilled]: (state) => {
      state.loading = false;
    },
    [postPincodesAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getPinocodesListAsync.pending]: (state) => {
      state.loading = true;
    },
    [getPinocodesListAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.pincodes = action.payload;
    },
    [getPinocodesListAsync.rejected]: (state) => {
      state.loading = false;
    },
  },
});

// export const {} = partialRolloutSlice.actions;

export default launchSlice.reducer;
